import { render, staticRenderFns } from "./CustomizationSelectionOptions.vue?vue&type=template&id=976f5550&lang=pug"
import script from "./CustomizationSelectionOptions.vue?vue&type=script&lang=js"
export * from "./CustomizationSelectionOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports